//const localUser = JSON.parse(localStorage.getItem('adminState'))

import { authApi, paymentApi, userApi, defaultApi } from '@/service/api'
import ReportProvider from '@/service/report'
//import router from '@/routes/routes'
import {
    GET_ADMIN_AREA, GET_REVENUE_SOURCE, GET_ATTACHMENT_TYPES,
    POST_BSL, GET_BSL, GET_INVOICE, POST_BLD, GET_BLD, GET_ROAD,
    POST_SOLID_WASTE, GET_SOLID_WASTE,

    POST_PRODUCTION_LINES,GET_UIM_FORECAST,GET_PRODUCTION_LINES,

    UPDATE_PROFILE, CHANGE_PASSWORD, POST_ADD_USER,

    FORGOT_PASSWORD, RESET_PASSWORD,

    GET_FACILITY, POST_UIM_FORECAST_DETAILS,

    POST_ORGANIZATION_DETAILS, POST_ADMINISTRATOR_DETAILS,
    POST_PRODUCT_SELECTION,  POST_FACILITY_DETAILS,  POST_UIM_FORECAST,
    POST_ORGANIZATION_DOCUMENT, GET_MFG_PRODUCT, GET_MFG_PRODUCT_TYPE,
    POST_FACILITY_DETAIL_REGISTER, POST_REVIEW_AND_SUBMIT
} from '@/store/_actiontypes'

import { SET_PACKAGE } from '@/store/_mutationtypes'

const state = {
    package_list: null,
}

const actions = {

    [UPDATE_PROFILE]({ commit }, payload) {
        return new Promise((resolve, reject) => {   
            userApi.post('/Api/UserUpdate', payload )
            .then(response => {           
                resolve(response)
            })
            .catch(error => {
                reject(error.response)
            })
        })
    },

    [CHANGE_PASSWORD]({ commit }, payload) {
        return new Promise((resolve, reject) => {   
            userApi.post('/Api/UserChangePassword', payload )
            .then(response => {           
                resolve(response)
            })
            .catch(error => {
                reject(error.response)
            })
        })
    },

    [POST_ADD_USER]({ commit }, payload) {
        return new Promise((resolve, reject) => {   
            userApi.post('/Api/UserAdd', payload )
            .then(response => {           
                resolve(response)
            })
            .catch(error => {
                reject(error.response)
            })
        })
    },


    [FORGOT_PASSWORD]({ commit }, payload) {
        return new Promise((resolve, reject) => {   
            userApi.post('/Api/UserForgotPassword', payload )
            .then(response => {           
                resolve(response)
            })
            .catch(error => {
                reject(error.response)
            })
        })
    },


    [RESET_PASSWORD]({ commit }, payload) {
        return new Promise((resolve, reject) => {   
            userApi.post('/Api/UserResetPassword', payload )
            .then(response => {           
                resolve(response)
            })
            .catch(error => {
                reject(error.response)
            })
        })
    },


    [POST_ORGANIZATION_DETAILS]({ commit }, payload) {
        return new Promise((resolve, reject) => {   
            userApi.post('/Api/Registration/ValidateOrganizationDetails', payload )
            .then(response => {           
                resolve(response)
            })
            .catch(error => {
                reject(error.response)
            })
        })
    },


    [POST_ADMINISTRATOR_DETAILS]({ commit }, payload) {
        return new Promise((resolve, reject) => {   
            userApi.post('/Api/Registration/ValidateAdmistrationDetails', payload )
            .then(response => {           
                resolve(response)
            })
            .catch(error => {
                reject(error.response)
            })
        })
    },


    [POST_PRODUCT_SELECTION]({ commit }, payload) {
        return new Promise((resolve, reject) => {   
            userApi.post('/Api/Registration/ValidateProductSelection', payload )
            .then(response => {           
                resolve(response)
            })
            .catch(error => {
                reject(error.response)
            })
        })
    },


    [POST_FACILITY_DETAILS]({ commit }, payload) {
        return new Promise((resolve, reject) => {   
            userApi.post('/Api/Registration/ValidateFacilityDetail', payload )
            .then(response => {           
                resolve(response)
            })
            .catch(error => {
                reject(error.response)
            })
        })
    },


    [POST_UIM_FORECAST]({ commit }, payload) {
        return new Promise((resolve, reject) => {   
            userApi.post('/Api/Registration/ValidateUimForecastRegister', payload )
            .then(response => {           
                resolve(response)
            })
            .catch(error => {
                reject(error.response)
            })
        })
    },

    [POST_UIM_FORECAST_DETAILS]({ commit }, payload) {
        return new Promise((resolve, reject) => {   
            userApi.post('/Api/Registration/UimForecast', payload )
            .then(response => {           
                resolve(response)
            })
            .catch(error => {
                reject(error.response)
            })
        })
    },
    

    [POST_ORGANIZATION_DOCUMENT]({ commit }, payload) {
        return new Promise((resolve, reject) => {   
            userApi.post('/Api/ValidateOrganizationDocument', payload )
            .then(response => {           
                resolve(response)
            })
            .catch(error => {
                reject(error.response)
            })
        })
    },

    [POST_FACILITY_DETAIL_REGISTER]({ commit }, payload) {
        return new Promise((resolve, reject) => {   
            userApi.post('/Api/Registration/ValidateFacilityDetail', payload )
            .then(response => {           
                resolve(response)
            })
            .catch(error => {
                reject(error.response)
            })
        })
    },
    
    [POST_REVIEW_AND_SUBMIT]({ commit }, payload) {
        return new Promise((resolve, reject) => {   
            userApi.post('/Api/Registration/SubmitStakeholder', payload )
            .then(response => {           
                resolve(response)
            })
            .catch(error => {
                reject(error.response)
            })
        })
    },

    [POST_PRODUCTION_LINES]({ commit }, payload) {
        return new Promise((resolve, reject) => {   
            userApi.post('/Api/ProductionLines', payload )
            .then(response => {           
                resolve(response)
            })
            .catch(error => {
                reject(error.response)
            })
        })
    },

    [GET_MFG_PRODUCT]({ commit }, payload) {
        return new Promise((resolve, reject) => {
        userApi.get('/Api/MfgProduct', { params: payload })
            .then(response => {      
                resolve(response)
            })
            .catch(error => {
                reject(error)
            })
        })
    },

    [GET_MFG_PRODUCT_TYPE]({ commit }, payload) {
        return new Promise((resolve, reject) => {
        userApi.get('/Api/MfgProductType', { params: payload })
            .then(response => {      
                resolve(response)
            })
            .catch(error => {
                reject(error)
            })
        })
    },

    [GET_PRODUCTION_LINES]({ commit }, payload) {
        return new Promise((resolve, reject) => {
        userApi.get('/Api/ProductionLines', { params: payload })
            .then(response => {      
                resolve(response)
            })
            .catch(error => {
                reject(error)
            })
        })
    },

    [GET_UIM_FORECAST]({ commit }, payload) {
        return new Promise((resolve, reject) => {
        userApi.get('/Api/UimForecast', { params: payload })
            .then(response => {      
                resolve(response)
            })
            .catch(error => {
                reject(error)
            })
        })
    },

    [GET_FACILITY]({ commit }, payload) {
        return new Promise((resolve, reject) => {
        userApi.get('/Api/Facility', { params: payload })
            .then(response => {      
                resolve(response)
            })
            .catch(error => {
                reject(error)
            })
        })
    },

    [GET_MFG_PRODUCT]({ commit }, payload) {
        return new Promise((resolve, reject) => {
        userApi.get('/Api/MfgProduct', { params: payload })
            .then(response => {      
                resolve(response)
            })
            .catch(error => {
                reject(error)
            })
        })
    },


    [GET_ADMIN_AREA]({ commit }, payload) {
        return new Promise((resolve, reject) => {
        userApi.get('/admin-area', { params: payload })
            .then(response => {      
                resolve(response)
            })
            .catch(error => {
                reject(error)
            })
        })
    },


    [GET_REVENUE_SOURCE]({ commit }, payload) {
        return new Promise((resolve, reject) => {
        userApi.get('/revenue-source', { params: payload })
            .then(response => {      
                resolve(response)
            })
            .catch(error => {
                reject(error)
            })
        })
    },  

    [GET_ATTACHMENT_TYPES]({ commit }, payload) {
        return new Promise((resolve, reject) => {
        userApi.get('/attachment-types', { params: payload })
            .then(response => {      
                resolve(response)
            })
            .catch(error => {
                reject(error)
            })
        })
    },

    [POST_BSL]({ commit }, payload) {
        return new Promise((resolve, reject) => {   
            userApi.post('/business-license', payload )
            .then(response => {           
                resolve(response)
            })
            .catch(error => {
                reject(error.response)
            })
        })
    },

    [GET_BSL]({ commit }, payload) {
        return new Promise((resolve, reject) => {
        userApi.get('/business-license', { params: payload })
            .then(response => {      
                resolve(response)
            })
            .catch(error => {
                reject(error)
            })
        })
    },

    [POST_BLD]({ commit }, payload) {
        return new Promise((resolve, reject) => {   
            userApi.post('/billboard', payload )
            .then(response => {           
                resolve(response)
            })
            .catch(error => {
                reject(error.response)
            })
        })
    },

    [GET_SOLID_WASTE]({ commit }, payload) {
        return new Promise((resolve, reject) => {
        userApi.get('/solidwaste', { params: payload })
            .then(response => {      
                resolve(response)
            })
            .catch(error => {
                reject(error)
            })
        })
    },

    [POST_SOLID_WASTE]({ commit }, payload) {
        return new Promise((resolve, reject) => {   
            userApi.post('/solidwaste', payload )
            .then(response => {           
                resolve(response)
            })
            .catch(error => {
                reject(error.response)
            })
        })
    },
     

    [GET_INVOICE]({ commit }, payload) {
        return new Promise((resolve, reject) => {
            ReportProvider.get('/Export', { params: payload })
            .then(response => {      
                resolve(response)
            })
            .catch(error => {
                reject(error)
            })
        })
    },


    [GET_BLD]({ commit }, payload) {
        return new Promise((resolve, reject) => {
        userApi.get('/billboard', { params: payload })
            .then(response => {      
                resolve(response)
            })
            .catch(error => {
                reject(error)
            })
        })
    },

    [GET_ROAD]({ commit }, payload) {
        return new Promise((resolve, reject) => {
        userApi.get('/road', { params: payload })
            .then(response => {      
                resolve(response)
            })
            .catch(error => {
                reject(error)
            })
        })
    }, 
}

const mutations = {
    [SET_PACKAGE](state, package_list) {
        state.packages = package_list
    },
}


export const application = {
    namespaced: true,
    state,
    actions,
    mutations
}